import { Grid, Typography } from '@mui/material';

import { FormPart } from '@modules/shared/components/FormPart';
import { CheckboxListField } from '@shared/fields/CheckboxListField';
import { getOptions } from '@shared/commonFunctions';
import { IDelaysFormProps } from '../interfaces';

export const DelaysForm = ({ delayData }: IDelaysFormProps) => {
  const optionsFundDelay = delayData.fundDelay || [];
  const optionsDelayFile = delayData.delayFile || [];
  const optionsCriticalFundDelay = delayData.criticalFundDelay || [];
  const leftPart = [
    {
      children: 'Delays',
      variant: 'h3',
      component: Typography,
    },
    {
      label: ' ',
      name: 'selectedFundDelay',
      options: getOptions(optionsFundDelay, 'userId', 'userName'),
      nextLine: true,
      component: CheckboxListField,
    },
  ];

  const middlePart = [
    {
      children: 'File Delays',
      variant: 'h3',
      component: Typography,
    },
    {
      label: ' ',
      name: 'selectedDelayFile',
      options: getOptions(optionsDelayFile, 'userId', 'userName'),
      nextLine: true,
      component: CheckboxListField,
    },
  ];

  const rightPart = [
    {
      children: 'Critical Delays',
      variant: 'h3',
      component: Typography,
    },
    {
      label: ' ',
      name: 'selectedCriticalFundDelay',
      options: getOptions(optionsCriticalFundDelay, 'userId', 'userName'),
      nextLine: true,
      component: CheckboxListField,
    },
  ];

  return (
    <>
      <Grid container spacing={5}>
        <Grid item xs={4}>
          <FormPart config={leftPart} />
        </Grid>
        <Grid item xs={4}>
          <FormPart config={middlePart} />
        </Grid>
        <Grid item xs={4}>
          <FormPart config={rightPart} />
        </Grid>
      </Grid>
    </>
  );
};
